enum LocalStorageItemKey {
  AccountId = "accountId",
  ApiKey = "apiKey",
  AuthToken = "authToken",
  CompanyName = "companyName",
  Email = "email",
  UserId = "userId",
  isLogged = 'isLogged'
}

abstract class LocalStorageService {
  public static getAccountId = () =>
    getLocalStorageItem(LocalStorageItemKey.AccountId);

  public static getApiKey = () =>
    getLocalStorageItem(LocalStorageItemKey.ApiKey);

  public static getAuthToken = () =>
    getLocalStorageItem(LocalStorageItemKey.AuthToken);

  public static getCompanyName = () =>
    getLocalStorageItem(LocalStorageItemKey.CompanyName);

  public static getEmail = () => getLocalStorageItem(LocalStorageItemKey.Email);

  public static getUserId = () =>
    getLocalStorageItem(LocalStorageItemKey.UserId);
    
  public static getIsLoggedfromLS = () => localStorage.getItem('isLogged')

  public static setAccountId = (accountId: string) =>
    setLocalStorageItem(LocalStorageItemKey.AccountId, accountId);

  public static setApiKey = (apiKey: string) =>
    setLocalStorageItem(LocalStorageItemKey.ApiKey, apiKey);

  public static setAuthToken = (authToken: string) =>
    setLocalStorageItem(LocalStorageItemKey.AuthToken, authToken);

  public static setCompanyName = (companyName: string) =>
    setLocalStorageItem(LocalStorageItemKey.CompanyName, companyName);

  public static setEmail = (email: string) =>
    setLocalStorageItem(LocalStorageItemKey.Email, email);

  public static setUserId = (userId: string) =>
    setLocalStorageItem(LocalStorageItemKey.UserId, userId);

  public static setIsLoggedfromLS = (data: string) =>
    setLocalStorageItem(LocalStorageItemKey.isLogged, data);
}

const getLocalStorageItem = (key: string) => {
  const value = window.localStorage.getItem(key);
  if (value === null) {
    throw new Error(`Missing "${key}" local storage item`);
  }
  return value;
};

const setLocalStorageItem = (key: string, value: string) =>
  window.localStorage.setItem(key, value);

export default LocalStorageService;
